import axios from 'axios';
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}`;
axios.defaults.withCredentials = true;

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = getCookie('csrftoken');
    if (token) {
      config.headers['X-CSRFToken'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// ----------------------------------
// Credit APIs
// ----------------------------------
export const getCredit = () => api.get('/api/accountview/');
export const getAcc = () => api.get('/api/accountinfo/');
export const regAcc = (formData) => api.post('/api/accregister/', formData);
export const reqWthd = (formDataWth) => api.post('/api/wthrequest/', formDataWth);






